import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import ReportsService from '@/services/ReportsService';
import _ from 'lodash';
import store from '@/store';


function initialState() {
    return {
        dropDownObject: {
            fromDate: new Date(),
            endDate: new Date(),
        },
        selected_movies: [],
        chartData: {
            labels: [],
            datasets: [
                //     {
                //     label: '',
                //     backgroundColor: '#f87979',
                //     data: []
                // }
            ]
        },
        chartOptions: {
            responsive: true,
            maintainAspectRatio: false
        }
    }
}

const state = initialState();

const mutations = {
    SET_MOVIE_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'fromDate':
                state.dropDownObject.fromDate = payload['event'] ? payload['event'] : null;
                break;
            case 'endDate':
                state.dropDownObject.endDate = payload['event'] ? payload['event'] : null;
                break;
            default: console.log('Municipalty Report :( Sorry, we are enable to set value.');
        }
    },
    SET_DROP_DOWN_CLEAR: (state, payload) => {
        state.dropDownObject.fromDate = payload
        state.dropDownObject.endDate = payload
    },
    CLEAR_DATES: (state, payload) => {
        switch (payload.name) {
            case 'fromDate':
                state.dropDownObject.fromDate = null;
                break;
            case 'endDate':
                state.dropDownObject.endDate = null;
                break;
            default: console.log('Unable To Clear Dates');
        }
    },
    SET_DATE_FILTER: (state, payload) => {
        if (payload == 'Day') {
            state.dropDownObject.fromDate = moment().valueOf();
            state.dropDownObject.endDate = moment().valueOf();
            store.dispatch('onFetch');
        }
        if (payload == 'Week') {
            state.dropDownObject.fromDate = moment().subtract(1, 'w').valueOf();
            state.dropDownObject.endDate = moment().valueOf();
            store.dispatch('onFetch');
        }
        if (payload == 'Month') {
            state.dropDownObject.fromDate = moment().subtract(1, 'M').valueOf();
            state.dropDownObject.endDate = moment().valueOf();
            store.dispatch('onFetch');
        }
    },
    SET_SELECTED_MOVIES: (state, payload) => {

        let index = payload.findIndex(e => { return e['md_id'] == 0 })

        if (index >= 0) {
            state.selected_movies = []
            store.dispatch('onFetch');
        }
        else {
            state.selected_movies = payload;
        }
    }
}

const actions = {
    ClearDates: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_DROP_DOWN_CLEAR', payload);
    },
    onMovieDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_MOVIE_DROP_DOWN_VALUES', payload);
    },
    clearDate: async ({ dispatch, commit, state }, payload) => {
        await commit('CLEAR_DATES', payload);
    },
    onFetch: async ({ dispatch, commit, state }, payload) => {
        if (state.dropDownObject && state.dropDownObject.fromDate != null && state.dropDownObject.endDate != null) {
            let loader = Vue.$loading.show();

            let postData = {
                fromDate: moment(state.dropDownObject.fromDate).format('YYYY-MM-DD'),
                endDate: moment(state.dropDownObject.endDate).format('YYYY-MM-DD'),
                SearchMovies: state.selected_movies || null
            }

            let totalmonths = moment(state.dropDownObject.endDate).diff(moment(state.dropDownObject.fromDate), 'months', true)


            if (totalmonths <= 3.00) {
                await ReportsService.GetMovieAnalytics(postData)
                    .then(async (response) => {
                        loader.hide();
                        const { data } = response;
                        if (data.status) {
                            if (data.Records && data.Records.length > 0) {
                                store.dispatch('onSetMovieAnalytics_ChartData', { Records: data.Records, Dates: state.dropDownObject })
                            }
                        } else {
                            Vue.toasted.show(data.message);
                        }
                    }).catch((error) => {
                        Vue.toasted.show("Catch Error on Movie Analytics Reports", error);
                    });
            }
            else {
                loader.hide();
                Vue.toasted.show("You can not Select From Date and To Date more than 3 Months");
            }
        } else {
            Vue.toasted.show("Please Select From Date and To Date");
        }
    },
    setSelectedMovies: async ({ dispatch, commit, state }, payload) => {
        commit('SET_SELECTED_MOVIES', payload);
    },
    OnSelectFilter: async ({ dispatch, commit, state }, payload) => {
        commit('SET_DATE_FILTER', payload);
    }
}

const getters = {
    getFromDate: state => state.dropDownObject.fromDate,
    getEndDate: state => state.dropDownObject.endDate,
    getSelectedMovies: state => state.selected_movies
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/MovieAnalyticsStore.js